import { ButtonHTMLAttributes } from "react";
import styled, { css } from "styled-components/macro";
import { DefaultFont } from "../../styles/fonts";

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  bold?: boolean;
  loading?: boolean;
}

export const StyledButton = styled.button<IButton>`
  border: 0;
  outline: none;
  padding: 0.5em;
  border-radius: 6px;
  transition: 0.3s;

  & > span {
    position: relative;
  }

  &:hover {
    cursor: pointer;
  }

  ${DefaultFont};
  color: #ffffff;
  background-color: ${(props) => props.theme.colors.primary};

  font-weight: ${(props) =>
    props.bold ? 600 : props.theme.text.default.weight};

  @media ${(props) => props.theme.media.phone} {
    font-weight: ${(props) =>
      props.bold ? 600 : props.theme.text.default.mobileWeight};
  }

  ${(props) =>
    props.loading &&
    css`
      overflow: hidden;
      cursor: wait;
      pointer-events: none;
      position: relative;
      opacity: 0.7;

      ::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 150%;
        height: 100%;
        background: repeating-linear-gradient(
          60deg,
          transparent,
          transparent 0.75rem,
          ${(props) => props.theme.colors.fourtly} 0.75rem,
          ${(props) => props.theme.colors.fourtly} 1.5rem
        );
        animation: load 1s infinite linear;
      }
    `};

  &:hover:enabled {
    background-color: #cb5210;
  }

  &:disabled {
    opacity: 0.7;
  }

  &:disabled:hover {
    animation: shake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }
    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }

  @keyframes load {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-1.75rem);
    }
  }
`;
